export const MARKETING_CHANNELS = ['EMAIL', 'SMS', 'WHATSAPP', 'PUSH', 'MULTI'] as const;

export const CAMPAIGN_LIFECYCLE = [
  'DRAFT',
  'REVIEW',
  'APPROVED',
  'SCHEDULED',
  'RUNNING',
  'COMPLETED',
  'ARCHIVED',
] as const;

export const JOURNEY_TRIGGERS = [
  { value: 'LEAD_CAPTURED', label: 'Lead captured' },
  { value: 'LEAD_SCORED', label: 'Lead scored' },
  { value: 'CAMPAIGN_OPENED', label: 'Campaign opened' },
  { value: 'CAMPAIGN_CLICKED', label: 'Campaign clicked' },
  { value: 'CUSTOMER_PURCHASED', label: 'Customer purchased' },
  { value: 'CONVERSION', label: 'Conversion' },
] as const;

export const ATTRIBUTION_MODELS = [
  { value: 'FIRST_TOUCH', label: 'First touch' },
  { value: 'LAST_TOUCH', label: 'Last touch' },
  { value: 'LINEAR', label: 'Linear' },
  { value: 'MULTI_TOUCH', label: 'Multi-touch' },
] as const;

export const SEGMENT_TYPES = [
  { value: 'DYNAMIC', label: 'Dynamic' },
  { value: 'STATIC', label: 'Static' },
  { value: 'SAVED', label: 'Saved' },
] as const;

export function campaignStatusClass(status: string): string {
  switch (status) {
    case 'RUNNING':
      return 'bg-emerald-100 text-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-300';
    case 'COMPLETED':
      return 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300';
    case 'APPROVED':
    case 'SCHEDULED':
      return 'bg-blue-100 text-blue-800 dark:bg-blue-950/40 dark:text-blue-300';
    case 'REVIEW':
      return 'bg-amber-100 text-amber-900 dark:bg-amber-950/40 dark:text-amber-300';
    case 'ARCHIVED':
      return 'bg-slate-200 text-slate-600 dark:bg-slate-800 dark:text-slate-400';
    default:
      return 'bg-violet-50 text-violet-800 dark:bg-violet-950/40 dark:text-violet-300';
  }
}

export function journeyStatusClass(status: string): string {
  if (status === 'ACTIVE') return 'bg-emerald-100 text-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-300';
  if (status === 'DRAFT') return 'bg-violet-50 text-violet-800 dark:bg-violet-950/40 dark:text-violet-300';
  return 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300';
}
